import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import Loader from '../../components/Loader'
import { getById } from '../../lib/RestApi/customApiHandler'
import AddBusinessCategory from './AddBusinessCategory'
export default function EditBusinessCategory() {
  const params = useParams()
  const [businessCategory, setBusinessCategory] = useState('')
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    getById('/business-category', params.businessCategoryId).then((res) => {
      setBusinessCategory(res.data)
      setLoading(false)
    })
  }, [params.businessCategoryId])

  return <> {loading ? <Loader /> : <AddBusinessCategory businessCategory={businessCategory} />} </>
}
